import { render, staticRenderFns } from "./DlgArticleEmailGenerator.vue?vue&type=template&id=cd61cf02&scoped=true&"
import script from "./DlgArticleEmailGenerator.vue?vue&type=script&lang=ts&"
export * from "./DlgArticleEmailGenerator.vue?vue&type=script&lang=ts&"
import style0 from "./DlgArticleEmailGenerator.vue?vue&type=style&index=0&id=cd61cf02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd61cf02",
  null
  
)

export default component.exports